<template>
  <div class="contact-container">
    <!-- HERO DE CONTACTO -->
    <section class="contact-hero dark-section">
      <div class="hero-content">
        <h1 class="display-3 fw-bold hero-title">Contáctame</h1>
        <h3 class="fw-normal hero-subtitle">Hablemos sobre tu proyecto</h3>
        <p class="lead">
          Estoy aquí para ayudarte a hacer realidad tus ideas digitales
        </p>
      </div>
    </section>

    <!-- INFORMACIÓN DE CONTACTO -->
    <section class="contact-info light-section">
      <div class="container">
        <div class="contact-grid">
          <!-- INFORMACIÓN PRINCIPAL -->
          <div class="contact-main">
            <h2 class="section-title">¿Listo para comenzar?</h2>
            <p class="contact-description">
              Trabajo con negocios de Cienfuegos y clientes por Internet.
              Generalmente respondo en menos de 1 hora.
            </p>

            <div class="contact-details">
              <div class="contact-item">
                <div class="contact-icon">📞</div>
                <div class="contact-text">
                  <h4>Teléfono / WhatsApp</h4>
                  <p>5352940801</p>
                  <small>Lunes a Sábado - 1:00pm a 10:00pm</small>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon">📧</div>
                <div class="contact-text">
                  <h4>Email</h4>
                  <p>leonar2.if@gmail.com</p>
                  <small>Siempre disponible</small>
                </div>
              </div>

              <div class="contact-item">
                <div class="contact-icon">🌎</div>
                <div class="contact-text">
                  <h4>Idiomas</h4>
                  <p>Español (nativo), Inglés (básico)</p>
                </div>
              </div>
            </div>
          </div>

          <!-- BOTONES DE ACCIÓN -->
          <div class="contact-actions">
            <h3>Contáctame directamente</h3>
            <div class="action-buttons">
              <a href="tel:5352940801" class="action-btn btn-call">
                <span class="btn-icon">📞</span>
                Llamar ahora
              </a>

              <a
                href="https://wa.me/5352940801"
                target="_blank"
                class="action-btn btn-whatsapp"
              >
                <span class="btn-icon">💬</span>
                WhatsApp
              </a>

              <a
                href="mailto:leonar2.if@gmail.com"
                class="action-btn btn-email"
              >
                <span class="btn-icon">📧</span>
                Email
              </a>

              <!-- Reemplaza los botones deshabilitados por esto: -->
              <a
                href="https://instagram.com/leonar2.dev"
                target="_blank"
                class="action-btn"
              >
                <span class="btn-icon">📱</span>
                Instagram
              </a>

              <a
                href="https://github.com/leonar2"
                target="_blank"
                class="action-btn"
              >
                <span class="btn-icon">💻</span>
                GitHub
              </a>

              <button class="action-btn btn-linkedin" disabled>
                <span class="btn-icon">💼</span>
                LinkedIn
                <small class="coming-soon">(próximamente)</small>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CARTEL PROMOCIONAL -->
    <section class="promo-banner">
      <div class="container">
        <div class="promo-content">
          <div class="promo-icon">⚡</div>
          <div class="promo-text">
            <h3>¿Quieres una cotización más rápida?</h3>
            <p>
              Completa el formulario y recibirás una respuesta prioritaria con
              precios y plazos exactos
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- FORMULARIO DE COTIZACIÓN -->
    <section class="contact-form light-section">
      <div class="container">
        <h2 class="section-title text-center">Solicitar Cotización</h2>
        <p class="form-subtitle text-center">
          Completa este formulario para recibir una cotización detallada
        </p>

        <form @submit.prevent="submitForm" class="quote-form">
          <div class="form-grid">
            <!-- COLUMNA 1 -->
            <div class="form-column">
              <div class="form-group">
                <label for="nombre">Nombre completo *</label>
                <input
                  type="text"
                  id="nombre"
                  v-model="formData.nombre"
                  required
                  placeholder="Tu nombre completo"
                />
              </div>

              <div class="form-group">
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  v-model="formData.email"
                  placeholder="tu@email.com (opcional)"
                />
              </div>

              <div class="form-group">
                <label for="negocio">Tipo de negocio (hasta 3 palabras)</label>
                <input
                  type="text"
                  id="negocio"
                  v-model="formData.negocio"
                  placeholder="Ej: Restaurante, Tienda online"
                  maxlength="30"
                />
              </div>

              <!-- Agrega este campo en el formulario (después de dirección): -->
              <div class="form-group">
                <label for="web">Sitio web actual</label>
                <input
                  type="url"
                  id="web"
                  v-model="formData.web"
                  :placeholder="
                    formData.servicio === 'Optimización'
                      ? 'https://tunegocio.com (requerido)'
                      : 'https://tunegocio.com (opcional)'
                  "
                  :required="formData.servicio === 'Optimización'"
                />
              </div>
            </div>

            <!-- COLUMNA 2 -->
            <div class="form-column">
              <div class="form-group">
                <label for="servicio">Tipo de servicio *</label>
                <select id="servicio" v-model="formData.servicio" required>
                  <option value="" hidden>Selecciona un servicio</option>

                  <option value="Desarrollo Web">
                    Desarrollo de Páginas Web
                  </option>
                  <option value="Optimización">
                    Optimización de Sitios Webs
                  </option>
                  <option value="Automatización">
                    Automatización de Procesos
                  </option>
                  <option value="IA">Implementación de IAs</option>
                </select>
              </div>

              <div class="form-group">
                <label for="urgencia">Urgencia del servicio</label>
                <select id="urgencia" v-model="formData.urgencia">
                  <option value="" hidden>Selecciona urgencia</option>
                  <option value="Baja">Baja (1-2 semanas)</option>
                  <option value="Media">Media (1 semana)</option>
                  <option value="Alta">Alta (2-3 días)</option>
                  <option value="Urgente">Urgente (24 horas)</option>
                </select>
              </div>

              <div class="form-group full-width">
                <label for="descripcion">Descripción de tu proyecto *</label>
                <textarea
                  id="descripcion"
                  v-model="formData.descripcion"
                  rows="5"
                  required
                  placeholder="Describe tu negocio y lo que necesitas... (mínimo 30 palabras)"
                  :class="{ error: showWordError }"
                ></textarea>
                <div class="word-count">
                  {{ wordCount }} palabras
                  {{ wordCount < 30 ? "(mínimo 30)" : "" }}
                </div>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button
              type="button"
              class="btn-whatsapp-form"
              @click="openWhatsApp"
              :disabled="!isFormValid"
            >
              💬 Enviar por WhatsApp
            </button>

            <button type="submit" class="btn-submit" :disabled="!isFormValid">
              📧 Enviar cotización
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed, reactive } from 'vue';

// Datos del formulario
const formData = reactive({
  nombre: '',
  email: '',
  negocio: '',
  direccion: '',
  servicio: '',
  urgencia: '',
  descripcion: '',
  web: '',
});

const showWordError = ref(false);

// Computed: Contador de palabras y validación
const wordCount = computed(() => {
  return formData.descripcion.trim()
    ? formData.descripcion.trim().split(/\s+/).length
    : 0;
});

// Computed: Para validar si el campo web es requerido
const isWebRequired = computed(() => {
  return formData.servicio === 'Optimización';
});

const isFormValid = computed(() => {
  return formData.nombre.trim() && formData.servicio && wordCount.value >= 30;
});

// Método para abrir WhatsApp con mensaje pre-escrito
// Reemplaza el método openWhatsApp por este:

// Método para enviar formulario (solo muestra mensaje)
const submitForm = () => {
  if (!isFormValid.value) return;

  alert(
    '¡Gracias! En una versión futura esto enviaría un email. Por ahora usa el botón de WhatsApp para contacto inmediato.'
  );
  // Reemplaza el método openWhatsApp por este:
  const openWhatsApp = () => {
    if (!isFormValid.value) return;

    const mensaje = `¡Hola! 👋 Necesito una *COTIZACIÓN* para el servicio *${
      formData.servicio
    }*${formData.negocio ? ' de mi ' + formData.negocio : ''}.

📋 *Información del proyecto:*
${formData.descripcion}

${formData.urgencia ? `⏱️ *Urgencia:* ${formData.urgencia}` : ''}
${formData.email ? `📧 *Email:* ${formData.email}` : ''}
${formData.direccion ? `📍 *Dirección:* ${formData.direccion}` : ''}
${formData.web ? `🌐 *Web actual:* ${formData.web}` : ''}

*Otros datos:*
👤 *Nombre:* ${formData.nombre}`;

    const url = `https://wa.me/5352940801?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };
  // Reset form
  Object.keys(formData).forEach((key) => {
    formData[key] = '';
  });
};
</script>

<style scoped>
.contact-container {
  font-family: "Arial", sans-serif;
  width: 100%;
  margin-top: 0;
}

/* HERO */
.contact-hero {
  background-color: var(--color-surface);
  color: var(--color-text-primary);
  padding: 0 20px;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.hero-content .display-3 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero-subtitle {
  font-size: 1.5rem;
  color: var(--color-primary);
  margin-bottom: 1rem;
}

/* SECCIONES CLARAS/OSCURAS */
.dark-section {
  background-color: var(--color-surface);
  color: var(--color-text-primary);
}

.light-section {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  padding: 80px 20px;
}

/* INFORMACIÓN DE CONTACTO */
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-main .section-title {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
}

.contact-description {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: var(--color-text-secondary);
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.contact-icon {
  font-size: 1.5rem;
  margin-top: 0.2rem;
}

.contact-text h4 {
  margin: 0 0 0.3rem 0;
  color: var(--color-text-primary);
}

.contact-text p {
  margin: 0;
  font-weight: 600;
  color: var(--color-primary);
}

.contact-text small {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

/* BOTONES DE ACCIÓN */
.contact-actions h3 {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
}

.action-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.2rem 1rem;
  border: 2px solid var(--color-primary);
  border-radius: 12px;
  text-decoration: none;
  color: var(--color-text-primary);
  background: transparent;
  transition: all 0.3s ease;
  cursor: pointer;
  text-align: center;
  gap: 0.5rem;
}

.action-btn:hover:not(:disabled) {
  background: var(--color-primary);
  color: white;
  transform: translateY(-2px);
}

.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  border-color: var(--color-text-secondary);
}

.btn-icon {
  font-size: 1.5rem;
}

.coming-soon {
  font-size: 0.7rem;
  opacity: 0.8;
}

/* CARTEL PROMOCIONAL */
.promo-banner {
  background: linear-gradient(135deg, var(--color-primary) 0%, #0a58ca 100%);
  color: white;
  padding: 3rem 20px;
}

.promo-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
  text-align: left;
}

.promo-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.promo-text h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
}

.promo-text p {
  margin: 0;
  opacity: 0.9;
}

/* FORMULARIO */
.section-title {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.form-subtitle {
  font-size: 1.1rem;
  color: var(--color-text-secondary);
  margin-bottom: 3rem;
}

.quote-form {
  max-width: 1000px;
  margin: 0 auto;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-surface);
  color: var(--color-text-primary);
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-primary);
}

.form-group textarea.error {
  border-color: #dc3545;
}

.word-count {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  text-align: right;
}

/* ACCIONES DEL FORMULARIO */
.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.btn-whatsapp-form,
.btn-submit {
  padding: 1rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-whatsapp-form {
  background: #25d366;
  color: white;
}

.btn-whatsapp-form:hover:not(:disabled) {
  background: #128c7e;
  transform: translateY(-2px);
}

.btn-submit {
  background: var(--color-primary);
  color: white;
}

.btn-submit:hover:not(:disabled) {
  background: #0a58ca;
  transform: translateY(-2px);
}

.btn-whatsapp-form:disabled,
.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .contact-hero {
    min-height: 50vh;
    padding: 0 15px;
  }

  .hero-content .display-3 {
    font-size: 2.2rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .action-buttons {
    grid-template-columns: 1fr;
  }

  .promo-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .contact-main .section-title {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .light-section {
    padding: 60px 15px;
  }

  .section-title {
    font-size: 2rem;
  }

  .hero-content .display-3 {
    font-size: 1.8rem;
  }
}
/* Agrega al final de los estilos */
.btn-instagram {
  background: linear-gradient(
    45deg,
    #405de6,
    #5851db,
    #833ab4,
    #c13584,
    #e1306c,
    #fd1d1d
  );
  color: white;
  border: none;
}

.btn-github {
  background: #333;
  color: white;
  border: none;
}

.btn-instagram:hover,
.btn-github:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
  align-items: start; /* Esto ayuda a que ambas columnas tengan la misma altura */
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-height: 100%; /* Asegura que ambas columnas tengan la misma altura base */
}

/* RESPONSIVE PARA FORMULARIO */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
    max-width: 800px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .form-column {
    gap: 1.2rem;
  }
}

@media (max-width: 768px) {
  .contact-hero {
    min-height: 40vh;
    padding: 2rem 15px;
  }

  .hero-content .display-3 {
    font-size: 2.2rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
  }

  .contact-grid {
    gap: 2rem;
  }

  .contact-main .section-title {
    font-size: 2rem;
    text-align: center;
  }

  .contact-description {
    text-align: center;
    font-size: 1rem;
  }

  .contact-details {
    gap: 1.2rem;
  }

  .contact-item {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .contact-actions h3 {
    text-align: center;
  }

  .action-buttons {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }

  .action-btn {
    padding: 1rem;
    flex-direction: row;
    justify-content: flex-start;
    text-align: left;
  }

  .promo-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .promo-icon {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .form-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  .form-group {
    gap: 0.5rem;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    padding: 0.8rem;
    font-size: 16px; /* Evita zoom en iOS */
  }

  .form-actions {
    flex-direction: column;
    gap: 0.8rem;
  }

  .btn-whatsapp-form,
  .btn-submit {
    width: 100%;
    justify-content: center;
    padding: 1rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .light-section {
    padding: 50px 12px;
  }

  .contact-hero {
    min-height: 35vh;
    padding: 1.5rem 12px;
  }

  .hero-content .display-3 {
    font-size: 1.8rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .contact-main .section-title {
    font-size: 1.7rem;
  }

  .section-title {
    font-size: 1.7rem;
  }

  .contact-description,
  .form-subtitle {
    font-size: 0.95rem;
  }

  .contact-details {
    gap: 1rem;
  }

  .contact-text h4 {
    font-size: 1rem;
  }

  .contact-text p {
    font-size: 0.9rem;
  }

  .contact-text small {
    font-size: 0.8rem;
  }

  .action-btn {
    padding: 0.8rem;
    font-size: 0.9rem;
  }

  .btn-icon {
    font-size: 1.2rem;
  }

  .promo-banner {
    padding: 2rem 12px;
  }

  .promo-text h3 {
    font-size: 1.3rem;
  }

  .promo-text p {
    font-size: 0.9rem;
  }

  .form-group label {
    font-size: 0.9rem;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    padding: 0.7rem;
    font-size: 14px;
  }

  .word-count {
    font-size: 0.8rem;
  }

  .btn-whatsapp-form,
  .btn-submit {
    padding: 0.8rem;
    font-size: 0.9rem;
  }
}

/* RESPONSIVE ESPECÍFICO PARA TABLETS */
@media (min-width: 769px) and (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr;
    max-width: 700px;
  }

  .form-grid {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }

  .action-buttons {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* MEJORAS PARA DISPOSITIVOS TÁCTILES */
@media (hover: none) and (pointer: coarse) {
  .action-btn:hover:not(:disabled),
  .btn-whatsapp-form:hover:not(:disabled),
  .btn-submit:hover:not(:disabled) {
    transform: none;
  }

  .action-btn:active:not(:disabled),
  .btn-whatsapp-form:active:not(:disabled),
  .btn-submit:active:not(:disabled) {
    transform: scale(0.98);
  }
}

/* MEJORAS DE ACCESIBILIDAD EN MÓVIL */
@media (max-width: 768px) {
  .form-group input:focus,
  .form-group select:focus,
  .form-group textarea:focus {
    border-width: 3px;
  }

  .action-btn {
    min-height: 60px; /* Mejor área táctil */
  }
}

/* CORRECCIÓN PARA IOS */
@supports (-webkit-touch-callout: none) {
  .form-group input,
  .form-group select,
  .form-group textarea {
    font-size: 16px; /* Previene zoom en iOS */
  }
}
/* RESPONSIVE SOLO PARA LOS 3 ITEMS - SOLO MÓVIL */
@media (max-width: 768px) {
  .contact-details {
    gap: 1rem;
  }

  .contact-item {
    flex-direction: row; /* Mantener lado a lado */
    text-align: left; /* Texto a la izquierda */
    gap: 1rem;
    padding: 1.2rem;
    align-items: center; /* Centrar verticalmente */
  }

  .contact-icon {
    margin-top: 0;
    font-size: 1.8rem;
    flex-shrink: 0;
  }

  .contact-text h4 {
    font-size: 1rem;
  }

  .contact-text p {
    font-size: 0.9rem;
  }

  .contact-text small {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .contact-item {
    padding: 1rem;
    gap: 0.8rem;
  }

  .contact-icon {
    font-size: 1.5rem;
  }

  .contact-text h4 {
    font-size: 0.95rem;
  }

  .contact-text p {
    font-size: 0.85rem;
  }

  .contact-text small {
    font-size: 0.75rem;
  }
}
</style>
